import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/styles/makeStyles';


interface LoadingProps {
	styles?: React.CSSProperties;
}

const Loading: React.FC<LoadingProps> = ({ styles = {}, children }) => {

	const classes = useStyles();

	return (
		<div className={classes.container} style={{ ...styles }}>
			<CircularProgress color="primary" size={120} />
			{children && (
				<div className={classes.marginizeChildren}>
					{children}
				</div>
			)}
		</div>
	);
}

export default Loading;

const useStyles = makeStyles({
	container: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '76vh',
		position: 'absolute',
		width: '100vw',
		flexDirection: 'column'
	},
	marginizeChildren: {
		marginTop: '5vw'
	}
})